import { render } from "./AssignedReviews.vue?vue&type=template&id=dfbbb43c&scoped=true"
import script from "./AssignedReviews.vue?vue&type=script&lang=js"
export * from "./AssignedReviews.vue?vue&type=script&lang=js"

import "./AssignedReviews.vue?vue&type=style&index=0&id=dfbbb43c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfbbb43c"]])

export default __exports__